//MUI
import { Button } from "@mui/material";

// i18n
import { useTranslation } from "react-i18next";

const MNButton = ({ ariaLabel, onClick, children, ...rest }) => {
  const { t } = useTranslation();

  return (
    <Button
      aria-label={t(ariaLabel)}
      variant="contained"
      onClick={onClick}
      {...rest}
    >
      {children}
    </Button>
  );
};

export default MNButton;
